import PropTypes from "prop-types";

import { Badge } from "@/components/ui/badge";

/** States whether any row can be reached, as "Emailable" or "Not Callable". */
const ReachabilityBadge = ({ label, isReachable }) => (
  <Badge variant={isReachable ? "success" : "secondary"}>
    {isReachable ? label : `Not ${label}`}
  </Badge>
);

ReachabilityBadge.propTypes = {
  label: PropTypes.string.isRequired,
  isReachable: PropTypes.bool.isRequired,
};

export default ReachabilityBadge;
